module.exports = __webpack_public_path__ + "static/media/social_icon_twitter.2d8eb5e3.svg";